<template>
  <div></div>
</template>

<script>
import { CLIENT_API_URL } from '../../../constants/Environment';
import html2pdf from 'html2pdf.js';
import printJS from 'print-js';
import axios from 'axios';

export default {
  name: 'PrintPreOrder',

  created() {
    this.$root.$on('print-pre-order-pdf', this.printPDF);
  },

  beforeDestroy() {
    this.$root.$off('print-pre-order-pdf');
  },

  methods: {
    async printPDF(preOrderId) {
      let objectToPrint;
      try {
        const response = await axios.get(
          `${CLIENT_API_URL}/pre-orders/${preOrderId}/print`
        );
        objectToPrint = response.data;
      } catch (error) {
        console.error('Error retrieving pre-order print data: ' + error);
        return;
      }

      const fileName = objectToPrint.fileName ?? objectToPrint.FileName ?? 'PROFORMA';
      const htmlData = objectToPrint.htmlData ?? objectToPrint.HTMLData ?? objectToPrint.htmlData ?? '';

      const opt = {
        margin: [20, 20, 20, 20],
        filename: fileName + '.pdf',
        html2canvas: { y: 0, scrollY: 0, scale: 2, useCORS: true },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
      };

      html2pdf()
        .set(opt)
        .from(htmlData)
        .outputPdf()
        .then(function(pdf) {
          printJS({
            printable: btoa(pdf),
            type: 'pdf',
            base64: true
          });
        });
    }
  }
};
</script>
